module.exports = __webpack_public_path__ + "static/media/settings-input.e93b1c82.svg";